import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CpfCnpjPipe, EmailValidPipe, PhoneNumberPipe, SafeUrlPipe, TruncatePipe } from "../pipes";

const PIPES = [
    CpfCnpjPipe,
    EmailValidPipe,
    PhoneNumberPipe,
    TruncatePipe,
    SafeUrlPipe,
];

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        ...PIPES
    ],
    exports: [
        CommonModule,
        ...PIPES
    ],
    providers: [],
})

export class PipeModule { }